import React, {useState, useEffect} from 'react';
import 'fontsource-roboto';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import Warning from '../Components/Warning';

export default function StepOptions(props) {
  const [options, setOptions] = useState([]);
  const [checkedOptions, setCheckedOptions] = useState([]);
  const ignoredOptionProperties = ['id', 'label'];

  useEffect(() => {
    setOptions(props.step.options.filter(filterOptions));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filterOptions = option => {
    // verificam daca in props.data exista o proprietate cu numele diferit de id, label sau nextStep si filtram dupa caz
    const keys = Object.keys(option).filter(key => !~ignoredOptionProperties.indexOf(key));
    for (let i = 0; i < keys.length; i++) {
      if (props.data.hasOwnProperty(keys[i]) && option[keys[i]] !== props.data[keys[i]])
        return false;
    }
    return true;
  };

  const handleOptionsChange = (option) => () => {
    const currentIndex = checkedOptions.indexOf(option.id);
    const newChecked = [...checkedOptions];

    if (currentIndex === -1)
      newChecked.push(option.id);
    else
      newChecked.splice(currentIndex, 1);

    setCheckedOptions(newChecked);
  };

  const handleStepComplete = () => {
    props.onChange(checkedOptions);
  };

  return (
    <Grid container spacing={1} alignItems='stretch'>
      {options.map((option, index) =>
        // {props.step.groupBy && option[props.step.groupBy] && (index === 0 || option[props.step.groupBy] !== options[index - 1][props.step.groupBy])
        //   <Grid item xs={12}>
        //     <Typography variant='subtitle2' color='primary'>{option[props.step.groupBy]}</Typography>
        //   </Grid>
        // }
        <Grid key={option.id} item xs={props.step.xs ? props.step.xs : 12} sm={props.step.sm ? props.step.sm : 6} md={props.step.md ? props.step.md : 3}>
          <FormControlLabel
            control={
              <Checkbox size='small' color='primary' style={{padding: '0px 8px'}}
                checked={!!~checkedOptions.indexOf(option.id)}
                onChange={handleOptionsChange(option)}
              />
            }
            label={
              <Typography color='primary'>
                {option.label}
              </Typography>
            }
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <FormControlLabel style={{marginLeft: '0px'}}
          control={
            <Checkbox size='small' disableRipple edge='start' color='secondary'
              checked={checkedOptions.length > 0} // using checkedOptions.length === options.length will make a grey checkbox for indeterminate value
              indeterminate={checkedOptions.length > 0 && checkedOptions.length !== options.length}
              onChange={() => {
                setCheckedOptions(checkedOptions.length === options.length ? [] : options.map(option => option.id));
              }}
            />
          }
          label={
            <Typography color='secondary'>{checkedOptions.length === options.length ? 'Deselecteaza tot' : 'Selecteaza tot'}</Typography>
          }
        />
        <Box style={{float: 'right'}}>
          {props.step.isRequired && checkedOptions.length === 0
            ? <Warning>Selectati cel putin o optiune</Warning>
            : <Button variant='contained' color='primary'
                onClick={handleStepComplete}
              >
                Continua
              </Button>
          }
        </Box>
      </Grid>
    </Grid>
  );
}